import { ModalOrigin } from 'data/App/types'

import * as AT from './actionTypes'

export type DepositActionType = {
  payload: {
    readonly currency?: string
    readonly isVerification?: boolean
    readonly origin?: ModalOrigin
  }
  type: typeof AT.OPEN
}

const open = ({
  currency,
  isVerification,
  origin
}: {
  currency?: string
  isVerification?: boolean
  origin?: ModalOrigin
}): DepositActionType => ({
  payload: { currency, isVerification, origin },
  type: AT.OPEN
})

export default { open }
